$(function() {
	//ヘッダー
    $(window).on("scroll", function() {
        if ($(this).scrollTop() > 10) {
            $(".header-wrapper").addClass("is-fixed");
        } else {
			$(".header-wrapper").removeClass("is-fixed");
        }
    });
    //ヘッダーメニュー
    $('header-menu details').hover(
    function () {
        $(this).attr('open', true);
    },
    function () {
        $(this).removeAttr('open');
    }
    );

    // summaryクリック無効
    $('header-menu summary').on('click', function (e) {
    e.preventDefault();
    });
    //SPメニュー内アコーディオン
    $('.l-menu-parent > li').each(function () {
    const $item = $(this);
    const $trigger = $item.children('a');
    const $childMenu = $item.children('.l-menu-child');

    if ($childMenu.length) {
        // 子メニューありの印
        $trigger.addClass('has-child');

        $trigger.on('click', function (e) {
            
                e.preventDefault();

                $childMenu.stop().slideToggle(300);

                // 開閉状態クラス
                $trigger.toggleClass('is-open');
            
        });
    }
    });

    //フッターアコーディオン
    $('.l-footer__menu-parent > li').each(function () {
    const $item = $(this);
    const $trigger = $item.children('a');
    const $childMenu = $item.children('.l-footer__menu-child');

    if ($childMenu.length) {
        // 子メニューありの印
        $trigger.addClass('has-child');

        $trigger.on('click', function (e) {
            if (window.matchMedia( "(max-width: 767px)" ).matches) {
                e.preventDefault();

                $childMenu.stop().slideToggle(300);

                // 開閉状態クラス
                $trigger.toggleClass('is-open');
            }
            else{
            	e.preventDefault();
            }
        });
    }
    });
})
